import PropTypes from 'prop-types';
import SquareImage from '@/components/component-library/Image/KeakieImageSquare';

const ProfileImage = ({ assets, ...props }) => {
  return (
    <SquareImage
      assetsObj={ assets }
      className='user-image'
      disableNextImage // Images come from external sources, with dynamic domains. https://nextjs.org/docs/messages/next-image-unconfigured-host
      fallbackImageSrc='/static/icons/apple-touch-icon.png'
      isProfile
      loading={ !assets }
      { ...props }
    />
  );
};

ProfileImage.propTypes = { assets: PropTypes.object };

ProfileImage.defaultProps = { assets: null };

export default ProfileImage;